import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerCategoryService {

constructor(private ws: PostmethodService) { }

  customerCategoryCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "customerCategoryMaster");
  }
}
